import { Box, SxProp } from '@primer/react';
import { ReactNode } from 'react';

export const FlexBox = (props: { sx?: SxProp['sx']; children: ReactNode }) => (
  <Box sx={{ ...props.sx, display: 'flex' }}>{props.children}</Box>
);
